export default __webpack_public_path__ + "static/media/Group9218.6caefa5d.svg";